import { Box, Stepper, Step, StepLabel, Paper } from "@mui/material";

import { useState, useEffect } from "react";
import { CheckoutProvider, useCheckout } from "../checkout/CheckoutContext";

import ClientStep from "../checkout/steps/ClientStep";
import AddressStep from "../checkout/steps/AddressStep";
import ShippingStep from "../checkout/steps/ShippingStep";
import PaymentStep from "../checkout/steps/PaymentStep";
import ReviewStep from "../checkout/steps/ReviewStep";
import CreditCardStep from "../checkout/steps/CreditCardStep"; 
import PixStep from "../checkout/steps/PixStep"; 

const baseSteps = [
    "Dados do cliente",
    "Endereço",
    "Frete",
    "Pagamento",
    "Revisão",
];

function CheckoutContent() {
    const { activeStep, checkoutData } = useCheckout();

    const [isCardPayment, setIsCardPayment] = useState(true);

    const [steps, setSteps] = useState(["Dados do cliente", "Endereço", "Frete", "Pagamento", "Revisão"]);

    useEffect(() => {

        if (checkoutData.payment.method === "credit") {
            setIsCardPayment(true);
            setSteps(["Dados do cliente", "Endereço", "Frete", "Cartão de crédito", "Revisão"]);
        } else if (checkoutData.payment.method === "pix") {
            setIsCardPayment(false);
            setSteps(["Dados do cliente", "Endereço", "Frete", "Pagamento", "Revisão", "PIX"]);
        } else {
            setIsCardPayment(false);
            setSteps(baseSteps);
        }

    }, [checkoutData]);

    function renderStep() {
        switch (activeStep) {
            case 0:
                return <ClientStep />;
            case 1:
                return <AddressStep />;
            case 2:
                return <ShippingStep />;
            case 3:
                if (isCardPayment) {
                    return <CreditCardStep />;
                }
                return <PaymentStep />;
            case 4:
                return <ReviewStep />;
            case 5:
                if (!isCardPayment) {
                    return <PixStep />;
                }                    
            default:
                return null;
        }
    }

    return (
        <Paper sx={{ maxWidth: 900, mx: "auto", mt: 12, p: 4, mb: 12 }}>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <Box mt={4}>{renderStep()}</Box>
        </Paper>
    );
}

export default function Checkout() {
    return (
        <CheckoutProvider>
            <CheckoutContent />
        </CheckoutProvider>
    );
}
